/**
 * NSM waitlist confirmation — branded success page after Brevo waitlist signup.
 * Route: /waitlist-confirmation
 */
import React from "react";
import { Link } from "react-router-dom";
import BackToTop from "../components/elements/BackToTop";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import { useEffect, useState } from "react";

export default function WaitlistConfirmation() {
  const [scrollVisible, setScrollVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrollVisible(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <Header />
      <main className="nsm-waitlist-confirmation">
        <div className="container">
          <div className="nsm-waitlist-confirmation__card">
            <span className="nsm-waitlist-confirmation__badge">NSM 2026</span>
            <h1 className="nsm-waitlist-confirmation__title">You&apos;re on the waitlist</h1>
            <p className="nsm-waitlist-confirmation__text">
              Please check your email and confirm your subscription to join NSM 2026.
            </p>
            <p className="nsm-waitlist-confirmation__note">
              Confirmation is required before your subscription is completed.
            </p>
            <div className="nsm-waitlist-confirmation__actions">
              <Link to="/" className="nsm-waitlist-confirmation__btn nsm-waitlist-confirmation__btn--primary">
                Back to Home
              </Link>
              <Link to="/gallery" className="nsm-waitlist-confirmation__btn nsm-waitlist-confirmation__btn--secondary">
                Explore Gallery
              </Link>
            </div>
          </div>
        </div>
      </main>
      <BackToTop scroll={scrollVisible} />
      <Footer />
    </>
  );
}
